var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "diagramContainer" }, [
    _c("div", { staticClass: "drawerHeader" }, [
      _vm.selectedDrawer
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.selectedDrawer.dr_label
                  ? _vm.selectedDrawer.dr_label
                  : _vm.selectedDrawer.dr_id
              )
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "drawer-header-buttons-container",
          class: { "no-save-button": !_vm.showSaveButton }
        },
        [
          _c(
            "v-tooltip",
            {
              attrs: { left: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _c(
                        "v-btn",
                        _vm._g(
                          {
                            staticClass: "drawer-button",
                            attrs: { icon: "", height: "24px", width: "24px" },
                            on: {
                              click: function($event) {
                                return _vm.$emit("open-cassette-form")
                              }
                            }
                          },
                          on
                        ),
                        [
                          _c(
                            "v-icon",
                            { attrs: { size: "18", color: "white" } },
                            [_vm._v("add")]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ])
            },
            [
              _vm._v(" "),
              _c("span", [
                _vm._v(_vm._s(_vm.$t("Add") + " " + _vm.$t("Cassette")))
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "v-tooltip",
            {
              attrs: { left: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function(ref) {
                    var on = ref.on
                    return [
                      _vm.showSaveButton
                        ? _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "drawer-button",
                                attrs: {
                                  icon: "",
                                  height: "24px",
                                  width: "24px",
                                  disabled: !_vm.connectionsWereChanged
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.$emit("save-changes")
                                  }
                                }
                              },
                              on
                            ),
                            [
                              _c(
                                "v-icon",
                                { attrs: { size: "18", color: "white" } },
                                [_vm._v("save")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            },
            [_vm._v(" "), _c("span", [_vm._v(_vm._s(_vm.$t("SaveChanges")))])]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "drawerOuterContainer" },
      [
        _vm.selectedDrawer || _vm.cassettes
          ? _c("drawer", {
              attrs: {
                "selected-drawer": _vm.selectedDrawer,
                connections: _vm.connections,
                cassettes: _vm.cassettes
              },
              on: {
                "open-tray-connection-menu": _vm.openTrayConnectionMenu,
                "open-tube-form": _vm.openTubeForm,
                "open-cassette-form": function($event) {
                  return _vm.$emit("open-cassette-form", $event)
                },
                "open-delete-cassette-dialog": function($event) {
                  return _vm.$emit("open-delete-cassette-dialog", $event)
                }
              }
            })
          : _c("span", { staticClass: "selectDrawerMessage" }, [
              _vm._v("Please select a drawer")
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-50dec26b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50dec26b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/InsidePlan/SelectedDrawer.vue
// module id = null
// module chunks = 